import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import IntroductionsBoard from "../../components/CompatibilityControl/IntroductionsBoard";

// The Introductions board (founder go 2026-10-20) replaces
// CompatibilityListLayer here. The old table stays in the repo, unused, for
// one release. The board draws its own "Introductions" title and subtitle
// (approved mock-up), so the breadcrumb's second title is gone.
const CompatibilityList = () => {
  return (
    <MasterLayout>
      <IntroductionsBoard />
    </MasterLayout>
  );
};

export default CompatibilityList;
